<!--关于我们情页-->
<template>
  <!-- 路径 -->
  <div class="path">
    <span><router-link to="#" @click.prevent="goBack"> 返回</router-link></span>
    &nbsp; &gt; &nbsp;
    <span>详情</span>
    <!-- <span v-for="(item,index) in pathList" :key="index">
      &nbsp; &gt; &nbsp;
      <router-link v-if="item.categoryPath" :to="item.categoryPath"> {{item.name}}</router-link>
      <span v-else>{{item.name}}</span>
    </span> -->
  </div>
  <div class="card-box">
    <!-- 内容 -->
    <div class="newslist" v-if="content">
      <div class="news_title">{{ content.title }}</div>
      <div class="news_tit"> {{ content.publishTime }} </div>
      <div class="news_content" v-html="content.content"></div>
    </div>
  </div>
</template>

<script>
// import {formatDate} from '@/utils/datetime_utils.js'
export default {
  data() {
    return {
      content: null,
    }
  },
  async created() {

    const id = this.$route.query.id
    if (!id) {
      return
    }
    let { data: res } = await this.$http.get(`${this.$api.queryPublicNoticeDetail}/${id}`)
    if (res && res.body && res.body.info) {
      this.content = res.body.info || null
    }
  },
  mounted() {
  },
  methods: {
    goBack() {
      this.$router.go(-1); // 返回上一页
    }
  }
}
</script>

<style>
.news_title {
  display: block;
  padding: 1.0rem 0;
  font-size: 20px;
  font-weight: bold;
  color: #333;
  text-align: center;
}

.news_tit {
  display: block;
  padding: 0.5rem 0;
  font-size: 13px;
  color: #999;
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
}

.news_tit span {
  padding: 0 15px;
}

.news_content {
  display: block;
  /* padding: 16px; */
  text-align: justify !important;
  line-height: 180%;
  min-height: 400px;
  color: #666;
}

.news_content img {
  max-width: 100%;
  height: auto;
}

.news_bottom {
  padding: 16px;
  /* border: 1px solid #e8e8e8; */
  line-height: 30px;
}

.newslist img {
  max-width: 100%;
  height: auto;
}
</style>
